var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEns0)",
    d: "M6.9 10.526c.154.33.527.973.527.973l4.329-7.213L7.534 7.26a1.86 1.86 0 0 0-.6.664a3.1 3.1 0 0 0-.03 2.602zM5.19 12.9a4.9 4.9 0 0 0 1.886 3.531l4.676 3.283s-2.919-4.243-5.383-8.473a4.3 4.3 0 0 1-.497-1.44a2.3 2.3 0 0 1 0-.69l-.189.365a5.6 5.6 0 0 0-.501 1.628c-.052.6-.043 1.2.012 1.8zm11.91.574q-.247-.495-.527-.973l-4.324 7.213l4.221-2.97c.249-.171.454-.398.6-.668a3.1 3.1 0 0 0 .026-2.602zm1.71-2.374a4.88 4.88 0 0 0-1.886-3.531L12.25 4.286s2.918 4.243 5.383 8.473c.248.445.415.934.492 1.44a2.3 2.3 0 0 1 0 .69l.189-.365c.253-.514.42-1.063.506-1.628c.051-.6.043-1.2-.013-1.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEns0",
    x1: 7.962,
    x2: 18.572,
    y1: 5.939,
    y2: 18.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C97FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53B1EF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.12d9fbf5faa4e248e7a0ac61cd981752.svg";
export { ForwardRef as ReactComponent };